
/*
** This file is auto generated by the gen-version-file script.
** Don't edit this file manually, instead, run yarn nx gen-version-file <project>
** to update it.
*/
export const PACKAGE_NAME='@cbhq/identity-navigation'
export const PACKAGE_VERSION='11.0.0'
export const PACKAGE_VERSION_NAME='@cbhq/identity-navigation--11.0.0'
